<div name="card-notification" class="rounded-12 color-bg-white p-6 shadow-down">
	<h3 class="d-flex justify-content-between align-items-center">
		<ng-content select="[title]"></ng-content>
		<button class="btn btn-tertiary btn-min" (click)="cta.emit()">
			<i class="jr-icon close"></i>
		</button>
	</h3>
	<p>
		<ng-content select="[description]"></ng-content>
	</p>
	<ng-content select="[actions]"></ng-content>
</div>
